import { store } from '../core/store.js';
import { markers } from '../ui/screenMarker.js';
import { labels } from '../ui/labels.js';

var screenshot = { public: {} };

var captureHeight = 0;

function renderScreenshot (callback) {
  const renderer = store.webglRenderer;

  // Render the full scene stack so overlays, markers and labels are captured.
  renderFullScene();

  renderer.domElement.toBlob((blob) => {
    callback(blob);
  }, 'image/png');
}

function renderLoadingScreen (callback) {
  const renderer = store.webglRenderer;
  const scene = store.scene;
  const camera = store.camera;
  renderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
  renderer.render(scene, camera);
  renderer.domElement.toBlob((blob) => {
    blobToBase64(blob, callback);
  }, 'image/jpeg', 0.8);
}

function renderThumbnail (options, callback) {
  const renderer = store.webglRenderer;
  const scene = store.scene;
  const camera = store.camera;
  if (options !== undefined) {
    if (options.width && options.height) {
      renderer.setSize(options.width, options.height);
    }
  }

	window.requestAnimationFrame(() => {
		renderer.clear();
		renderer.render(scene, camera);
		renderer.domElement.toBlob((blob) => {
			if (options !== undefined) {
				if (options.width || options.height) {
					renderer.setSize(window.innerWidth, window.innerHeight);
				}
			}
			if (options !== undefined) {
				if (options.returnImage) {
					callback(blob);
					return;
				}
			}
			blobToBase64(blob, callback);
		}, 'image/jpeg', 0.8);
	});

}

function blobToBase64 (blob, callback) {
  var reader = new window.FileReader();
  reader.readAsDataURL(blob);
  reader.onloadend = () => {
    const base64Image = reader.result;
    callback(base64Image);
  };
}

screenshot.public.captureForMerge = function captureForMerge () {
	return new Promise((resolve, reject) => {
		renderScreenshot(resolve);
	});
}

screenshot.public.capture = function screenshotCanvas () {
	const renderer = store.webglRenderer;
  var currentTime = Math.floor(Date.now() / 1000);
  currentTime = String(currentTime).slice(2);
  var filename = 'screenshot_' + currentTime + '.png';
  var tempanchor = document.createElement('a');
  tempanchor.setAttribute('download', filename);

	if (captureHeight === 1080) {
		renderer.setSize(1920, 1080);
		store.camera.updateProjectionMatrix();
	} else if (captureHeight === 2160) {
		renderer.setSize(3840, 2160);
		store.camera.updateProjectionMatrix();
	} else if (captureHeight === 4320) {
		renderer.setSize(7860, 4320);
		store.camera.updateProjectionMatrix();
	}

  renderScreenshot((blob) => {
    tempanchor.href = URL.createObjectURL(blob);
    tempanchor.setAttribute('type', 'file');
    tempanchor.click();
  });
};

screenshot.createThumbnail = function createThumbnail (cb) {
  renderThumbnail({ width: 320, height: 180 }, cb);
};

// Renders the full scene stack (3D scene + overlays + HUD) exactly like
// the main render loop so that static image labels, screen labels, and
// markers all appear in the capture.
function renderFullScene () {
  const renderer = store.webglRenderer;
  renderer.clear();
  renderer.render(store.scene, store.camera);
  renderer.clearDepth();
  renderer.render(store.scene2, store.camera);
  renderer.clearDepth();
  markers.render();
  labels.render();
  renderer.render(store.sceneHUD, store.cameraHUD);
}

screenshot.createAnimationThumbnail = function createAnimationThumbnail (cb) {
  const renderer = store.webglRenderer;

  // Warm-up render — forces Three.js to compile shaders for newly-visible
  // materials and update shadow maps after a scene state change.
  renderFullScene();

  // Give the GPU real wall-clock time (not just frame ticks) to finish
  // shader compilation, shadow map updates, and texture uploads after the
  // scene state change.  200 ms is enough for complex scenes where
  // waitFrames(3) (~50 ms at 60 fps) was too short.
  setTimeout(() => {
    // Set an opaque background so transparent areas don't become black
    // blotches in the JPEG output (JPEG has no alpha channel).
    const prevClearAlpha = renderer.getClearAlpha();
    renderer.setClearColor(0x000000, 1);

    renderFullScene();

    // Restore the original transparent clear so the live canvas isn't affected.
    renderer.setClearColor(0x000000, prevClearAlpha);

    // Down-scale to thumbnail size via an off-screen 2D canvas.
    // We render at full canvas size so the HUD camera and label positions
    // are correct, then shrink the result to 320×180 for storage.
    const thumbCanvas = document.createElement('canvas');
    thumbCanvas.width = 320;
    thumbCanvas.height = 180;
    const ctx = thumbCanvas.getContext('2d');
    ctx.drawImage(renderer.domElement, 0, 0, 320, 180);
    thumbCanvas.toBlob((blob) => {
      blobToBase64(blob, cb);
    }, 'image/jpeg', 0.8);
  }, 200);
};

screenshot.renderLoadingScreen = (cb) => {
  renderLoadingScreen(cb);
};

screenshot.public.createThumbnail = screenshot.createThumbnail;
screenshot.public.setResolution = (height) => {
	if (isNaN(height)) return;
	captureHeight = height;
}

screenshot.public.getSettings = () => {
	return {
		resolution: captureHeight,
		format: 'png'
	}
}

export { screenshot };
